export const SAVE_REFERENCE = 'SAVE_REFERENCE';
export const SAVE_REFERENCE_SUCCESS = 'SAVE_REFERENCE_SUCCESS';
export const SAVE_REFERENCE_FAILURE = 'SAVE_REFERENCE_FAILURE';
export const ADD_REFERENCE_TO_THE_LIST = 'ADD_REFERENCE_TO_THE_LIST';
export const UPDATE_REFERENCE_IN_THE_LIST = 'UPDATE_REFERENCE_IN_THE_LIST';



// WEBPACK FOOTER //
// ./src/modules/ReferenceForm/actionTypes.js